import React from 'react';
import { useFingotiAuth } from '@fingoti/auth-js/react';

// Permission gating reads the granted scopes straight off the active session's
// access token (session.scopes). That is the authoritative set for the current
// context: at login the server grants every scope the user's role allows and
// reflects them back on the token, and when acting as a tenant the Act-As token
// carries that tenant context's scopes — so the same check transparently follows
// whichever org the session is currently scoped to, with no cookie bookkeeping.
//
// Scopes are "<realm>:read" / "<realm>:write" strings, e.g.
// "organisation:read". read and write are granted independently — a check
// requires that exact scope (write does NOT imply read). These checks gate UI
// only; the backend still enforces on every request.

export const useRoleCheck = () => {

    const { session } = useFingotiAuth();

    const _roleCheck = (scope) => {
        // session is null while the SDK hydrates / when signed out — treat as no
        // scopes, so gated affordances stay disabled until we have a real token.
        const scopes = session?.scopes;
        return Array.isArray(scopes) && scopes.includes(scope);
    };

    const RoleCheckWrapper = ({ children, scope }) => {

        if (_roleCheck(scope)) {
            return (
                <React.Fragment>
                    { children}
                </React.Fragment>
            );
        } else {
            return (
                <React.Fragment />
            );
        }

    };

    const roleCheck = (scope) => {
        //Reversed boolean for button disabling
        return !_roleCheck(scope);
    };

    return {
        roleCheck: roleCheck,
        RoleCheckWrapper: RoleCheckWrapper
    }

}
